import React from "react";

const TreasureBoxList = React.lazy(() => import('src/pages/treasure_box/TreasureBoxList'));
const AddTreasureBox = React.lazy(() => import('src/pages/treasure_box/AddTreasureBox'));
const EditTreasureBox = React.lazy(() => import('src/pages/treasure_box/EditTreasureBox'));
// const ViewTreasureBox = React.lazy(() => import('src/pages/treasure_box/ViewTreasureBox'));

const routes = [
    { path: '/dashboard/treasure-box-list/add', name: 'Add', element: AddTreasureBox },
    { path: '/dashboard/treasure-box-list/edit', name: 'Edit', element: EditTreasureBox },
    // { path: '/dashboard/treasure-box-list/view/:id', withParam: true, exact: true, name: "", element: ViewTreasureBox },
    { path: '/dashboard/treasure-box-list', name: 'Treasure Box', element: TreasureBoxList },
];

export default routes;